import React, { useEffect, useState } from "react";
import { PLATFORM_LOGO_SRC } from "@/utils";

interface BrandLogoProps {
  src: string;
  alt: string;
  className?: string;
  loading?: "eager" | "lazy";
}

/**
 * Brand logo image with platform fallback when tenant asset fails to load.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  src,
  alt,
  className,
  loading = "eager",
}) => {
  const [resolvedSrc, setResolvedSrc] = useState(src);

  useEffect(() => {
    setResolvedSrc(src);
  }, [src]);

  const handleError = (): void => {
    if (resolvedSrc !== PLATFORM_LOGO_SRC) {
      setResolvedSrc(PLATFORM_LOGO_SRC);
    }
  };

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      loading={loading}
      onError={handleError}
    />
  );
};

export default BrandLogo;
